import { render } from "./playlistComponent.vue?vue&type=template&id=12d0bb47&scoped=true"
import script from "./playlistComponent.vue?vue&type=script&lang=js"
export * from "./playlistComponent.vue?vue&type=script&lang=js"

import "./playlistComponent.vue?vue&type=style&index=0&id=12d0bb47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d0bb47"]])

export default __exports__